import React, { useEffect, useRef } from 'react';
import Table from "../../../../core/common/dataTable/index";

// Defina as interfaces para as props
interface ScrollableTableProps {
  dataSource: any[];  // Você pode substituir 'any' pelo tipo real dos seus dados
  columns: any[];     // Você pode substituir 'any' pelo tipo real das suas colunas
}

const ScrollableTable: React.FC<ScrollableTableProps> = ({ dataSource, columns }) => {
  // Tipando os refs corretamente
  const topScrollRef = useRef<HTMLDivElement | null>(null);
  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  
  useEffect(() => {
    const topScroll = topScrollRef.current;
    const tableContainer = tableContainerRef.current;
    
    if (!topScroll || !tableContainer) return;
    
    // Sincroniza a barra de rolagem superior com a tabela
    const handleTopScroll = () => {
      if (tableContainer) {
        tableContainer.scrollLeft = topScroll.scrollLeft;
      }
    };
    
    // Sincroniza a tabela com a barra de rolagem superior
    const handleTableScroll = () => {
      if (topScroll) {
        topScroll.scrollLeft = tableContainer.scrollLeft;
      }
    };
    
    topScroll.addEventListener('scroll', handleTopScroll);
    tableContainer.addEventListener('scroll', handleTableScroll);
    
    // Define a largura do div de rolagem superior igual à largura da tabela
    const updateScrollWidth = () => {
      // Encontra a tabela real dentro do container
      const tableElement = tableContainer.querySelector('table');
      if (tableElement) {
        const scrollContent = topScroll.querySelector('.scroll-content') as HTMLElement;
        if (scrollContent) {
          scrollContent.style.width = `${tableElement.offsetWidth}px`;
        }
      }
    };
    
    // Executa uma vez na inicialização e depois de um pequeno atraso para garantir que a tabela esteja renderizada
    updateScrollWidth();
    setTimeout(updateScrollWidth, 100);
    
    // Configura um MutationObserver para detectar mudanças na tabela
    const observer = new MutationObserver(updateScrollWidth);
    observer.observe(tableContainer, { 
      childList: true, 
      subtree: true, 
      attributes: true 
    });
    
    // Atualiza a largura quando o tamanho da janela muda
    window.addEventListener('resize', updateScrollWidth);
    
    // Cleanup
    return () => {
      topScroll.removeEventListener('scroll', handleTopScroll);
      tableContainer.removeEventListener('scroll', handleTableScroll);
      window.removeEventListener('resize', updateScrollWidth);
      observer.disconnect();
    };
  }, []);
  
  return (
    <div className="dual-scrollable-table">
      {/* Barra de rolagem superior */}
      <div className="top-scroll-container" ref={topScrollRef}>
        <div className="scroll-content"></div>
      </div>
      
      {/* Container da tabela com rolagem */}
      <div className="table-responsive custom-table scrollable-container" ref={tableContainerRef}>
        <Table dataSource={dataSource} columns={columns} />
      </div>
    </div>
  );
};

export default ScrollableTable;